// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pdf-indicators {
  position: absolute;
  top: -9999px;
  left: -9999px;
  width: 210mm;
  background: white;
  color: #333;
}
#pdf-indicators .pdf-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
#pdf-indicators .pdf-header-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
#pdf-indicators .pdf-header-title span {
  font-weight: 700;
  color: var(--sebrae-blue-6);
}
#pdf-indicators .pdf-header-info {
  font-size: 13px;
  font-weight: 500;
}
#pdf-indicators .pdf-header img {
  width: 100px;
  margin-bottom: 10px;
}
#pdf-indicators .pdf-header .pdf-divider {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 40px 0 12px;
  padding-bottom: 8px;
}
#pdf-indicators .pdf-header .pdf-divider h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: var(--sebrae-blue-pdf-title);
}
#pdf-indicators .pdf-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
#pdf-indicators .pdf-section {
  width: 210mm;
  height: 297mm;
  background: white;
  overflow: hidden;
  position: relative;
}
#pdf-indicators .pdf-section--content {
  padding: 10mm;
  padding-top: 22mm;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__bars {
  position: absolute;
  top: 0;
  left: -60px;
  width: 585px;
  height: auto;
  display: block;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__logo {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 158px;
  height: auto;
  display: block;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__bars-bottom {
  position: absolute;
  right: -160px;
  bottom: 0;
  width: 585px;
  height: auto;
  display: block;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__footer-meta {
  position: absolute;
  left: 10mm;
  bottom: 20px;
  display: flex;
  gap: 8px;
  align-items: flex-end;
  color: #617385;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__footer-id {
  font-size: 10px;
  font-weight: 400;
}
#pdf-indicators .pdf-section--content .pdf-page-decoration__footer-monthly-id {
  font-family: "Campuni";
  font-size: 8px;
  font-weight: 400;
}
#pdf-indicators .pdf-section--content h2 {
  font-family: "Campuni";
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--sebrae-blue-pdf-section);
}
#pdf-indicators .pdf-section--content .pdf-chart-box {
  width: 100%;
  height: 220px;
}
#pdf-indicators .pdf-section--content .pdf-values {
  gap: 24px;
  display: flex;
  margin: 10px 0 15px 0;
}
#pdf-indicators .pdf-section--content .pdf-values > div {
  flex: 1 1;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-blue3);
}
#pdf-indicators .pdf-section--content .pdf-values > div h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--sebrae-blue);
}
#pdf-indicators .pdf-section--content .pdf-values > div p {
  font-size: 19px;
  margin-top: 2px;
  font-weight: 600;
}
#pdf-indicators .pdf-section--content .pdf-values > div p.above {
  font-size: 11px;
  font-weight: 400;
  color: var(--sebrae-dark-green2);
}
#pdf-indicators .pdf-section--content .pdf-values > div p.below {
  font-size: 11px;
  font-weight: 400;
  color: var(--sebrae-red);
}
#pdf-indicators .pdf-section--content .pdf-header .pdf-divider {
  margin-top: 0;
}
#pdf-indicators .pdf-matriz-box {
  margin-top: 20px;
  transform: scale(0.9);
}
#pdf-indicators .pdf-page-break {
  page-break-before: always;
  break-before: page;
}
#pdf-indicators .cover-page {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
}
#pdf-indicators .cover-page .top-shape {
  position: absolute;
  top: 0;
  right: -80px;
  width: 138mm;
  line-height: 0;
}
#pdf-indicators .cover-page .top-shape-img {
  width: 100%;
  display: block;
}
#pdf-indicators .cover-page .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 75mm 20mm 50mm;
}
#pdf-indicators .cover-page .logo {
  width: 353px;
}
#pdf-indicators .cover-page .subtitle {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
}
#pdf-indicators .cover-page .subtitle__gray {
  color: #666;
}
#pdf-indicators .cover-page .subtitle .month {
  color: var(--sebrae-blue);
  font-weight: 700;
}
#pdf-indicators .cover-page .title {
  font-family: "Campuni";
  font-size: 22px;
  font-weight: 700;
  color: #222;
  text-align: center;
}
#pdf-indicators .cover-page .company-info {
  font-size: 16px;
  font-weight: 400;
  color: #243342;
  text-align: center;
  line-height: 1.6;
}
#pdf-indicators .cover-page .issue-date {
  font-size: 11px;
  color: #617385;
  text-align: center;
  padding: 0 0 20mm;
}
#pdf-indicators .cover-page .bottom-shape {
  position: absolute;
  bottom: 35px;
  left: -80px;
  width: 138mm;
  line-height: 0;
}
#pdf-indicators .cover-page .bottom-shape-img {
  width: 100%;
  display: block;
}
#pdf-indicators .cover-page .document-footer {
  gap: 4px;
  display: flex;
  font-weight: 400;
  color: #617385;
  padding: 4px 10mm 15px;
  align-items: end;
}
#pdf-indicators .cover-page .document-footer .document-id {
  font-size: 10px;
}
#pdf-indicators .cover-page .document-footer .monthly-id {
  font-family: "Campuni";
  font-size: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/post-credit/components/post-credit-pdf/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AACN;AAEM;EACE,gBAAA;EACA,2BAAA;AAAR;AAII;EACE,eAAA;EACA,gBAAA;AAFN;AAKI;EACE,YAAA;EACA,mBAAA;AAHN;AAMI;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAMM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAJR;AASE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,iBAAA;AATJ;AAWI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AATN;AAWM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AATR;AAYM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAVR;AAaM;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAXR;AAcM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;AAZR;AAeM;EACE,eAAA;EACA,gBAAA;AAbR;AAgBM;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;AAdR;AAkBI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;AAhBN;AAmBI;EACE,WAAA;EACA,aAAA;AAjBN;AAoBI;EACE,SAAA;EACA,aAAA;EACA,qBAAA;AAlBN;AAoBM;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;AAlBR;AAoBQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAlBV;AAqBQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAnBV;AAqBU;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AAnBZ;AAsBU;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AApBZ;AA2BE;EACE,aAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,qBAAA;AA1BJ;AA6BE;EACE,yBAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AA5BJ;AA8BI;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AA5BN;AA8BM;EACE,WAAA;EACA,cAAA;AA5BR;AAgCI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;AA9BN;AAiCI;EACE,YAAA;AA/BN;AAkCI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAhCN;AAkCM;EAAU,WAAA;AA/BhB;AAiCM;EACE,yBAAA;EACA,gBAAA;AA/BR;AAmCI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAjCN;AAoCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAlCN;AAqCI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAnCN;AAsCI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AApCN;AAsCM;EACE,WAAA;EACA,cAAA;AApCR;AAwCI;EACE,QAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAtCN;AAwCM;EACE,eAAA;AAtCR;AAyCM;EACE,sBAAA;EACA,cAAA;AAvCR","sourcesContent":["#pdf-indicators {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  width: 210mm;\n  background: white;\n  color: #333;\n\n  .pdf-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    &-title {\n      font-size: 16px;\n      font-weight: 500;\n      margin-bottom: 4px;\n      // font-family: \"Campuni\";\n\n      span {\n        font-weight: 700;\n        color: var(--sebrae-blue-6);\n      }\n    }\n\n    &-info {\n      font-size: 13px;\n      font-weight: 500;\n    }\n\n    img {\n      width: 100px;\n      margin-bottom: 10px;\n    }\n\n    .pdf-divider {\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n      margin: 40px 0 12px;\n      padding-bottom: 8px;\n\n      h2 {\n        margin: 0;\n        font-size: 19px;\n        font-weight: 700;\n        color: var(--sebrae-blue-pdf-title);\n      }\n    }\n  }\n\n  .pdf-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 20px;\n  }\n\n  .pdf-section {\n    width: 210mm;\n    height: 297mm;\n    background: white;\n    overflow: hidden;\n    position: relative;\n  }\n\n  .pdf-section--content {\n    padding: 10mm;\n    padding-top: 22mm;\n\n    .pdf-page-decoration {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n\n      &__bars {\n        position: absolute;\n        top: 0;\n        left: -60px;\n        width: 585px;\n        height: auto;\n        display: block;\n      }\n\n      &__logo {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 158px;\n        height: auto;\n        display: block;\n      }\n\n      &__bars-bottom {\n        position: absolute;\n        right: -160px;\n        bottom: 0;\n        width: 585px;\n        height: auto;\n        display: block;\n      }\n\n      &__footer-meta {\n        position: absolute;\n        left: 10mm;\n        bottom: 20px;\n        display: flex;\n        gap: 8px;\n        align-items: flex-end;\n        color: #617385;\n      }\n\n      &__footer-id {\n        font-size: 10px;\n        font-weight: 400;\n      }\n\n      &__footer-monthly-id {\n        font-family: \"Campuni\";\n        font-size: 8px;\n        font-weight: 400;\n      }\n    }\n\n    h2 {\n      font-family: \"Campuni\";\n      font-size: 16px;\n      font-weight: 600;\n      margin-bottom: 10px;\n      color: var(--sebrae-blue-pdf-section);\n    }\n\n    .pdf-chart-box {\n      width: 100%;\n      height: 220px;\n    }\n\n    .pdf-values {\n      gap: 24px;\n      display: flex;\n      margin: 10px 0 15px 0;\n\n      > div {\n        flex: 1;\n        padding: 16px;\n        border-radius: 4px;\n        border: 1px solid var(--sebrae-light-blue3);\n\n        h4 {\n          font-size: 16px;\n          font-weight: 600;\n          margin-bottom: 8px;\n          color: var(--sebrae-blue);\n        }\n\n        p {\n          font-size: 19px;\n          margin-top: 2px;\n          font-weight: 600;\n\n          &.above {\n            font-size: 11px;\n            font-weight: 400;\n            color: var(--sebrae-dark-green2);\n          }\n\n          &.below {\n            font-size: 11px;\n            font-weight: 400;\n            color: var(--sebrae-red);\n          }\n        }\n      }\n    }\n  }\n\n  .pdf-section--content .pdf-header .pdf-divider {\n    margin-top: 0;\n  }\n\n  .pdf-matriz-box {\n    margin-top: 20px;\n    transform: scale(0.9);\n  }\n\n  .pdf-page-break {\n    page-break-before: always;\n    break-before: page;\n  }\n\n  .cover-page {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: white;\n\n    .top-shape {\n      position: absolute;\n      top: 0;\n      right: -80px;\n      width: 138mm;\n      line-height: 0;\n\n      &-img {\n        width: 100%;\n        display: block;\n      }\n    }\n\n    .content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 32px;\n      padding: 75mm 20mm 50mm;\n    }\n\n    .logo {\n      width: 353px;\n    }\n\n    .subtitle {\n      font-size: 15px;\n      font-weight: 500;\n      text-align: center;\n\n      &__gray { color: #666; }\n\n      .month {\n        color: var(--sebrae-blue);\n        font-weight: 700;\n      }\n    }\n\n    .title {\n      font-family: \"Campuni\";\n      font-size: 22px;\n      font-weight: 700;\n      color: #222;\n      text-align: center;\n    }\n\n    .company-info {\n      font-size: 16px;\n      font-weight: 400;\n      color: #243342;\n      text-align: center;\n      line-height: 1.6;\n    }\n\n    .issue-date {\n      font-size: 11px;\n      color: #617385;\n      text-align: center;\n      padding: 0 0 20mm;\n    }\n\n    .bottom-shape {\n      position: absolute;\n      bottom: 35px;\n      left: -80px;\n      width: 138mm;\n      line-height: 0;\n\n      &-img {\n        width: 100%;\n        display: block;\n      }\n    }\n\n    .document-footer {\n      gap: 4px;\n      display: flex;\n      font-weight: 400;\n      color: #617385;\n      padding: 4px 10mm 15px;\n      align-items: end;\n      \n      .document-id {\n        font-size: 10px;\n      }\n\n      .monthly-id {\n        font-family: \"Campuni\";\n        font-size: 8px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
